import React from 'react'
import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material'
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom'

// The use of React.forwardRef will no longer be required for react-router-dom v6.
// See https://github.com/ReactTraining/react-router/issues/6056
const CustomRouterLink = React.forwardRef<HTMLAnchorElement, RouterLinkProps>((props, ref) => (
    <RouterLink innerRef={ref} {...props} />
))

interface MUIRouterLinkProps extends MuiLinkProps {
    href?: string
    disabled?: boolean
}

// RFC-compliant https://stackoverflow.com/a/31991870
const EXTERNAL_LINK_REGEX = /(?:^[a-z][a-z0-9+.-]*:|\/\/)/i

export const MUIRouterLink = ({
    href,
    disabled,
    children,
    underline = 'none',
    target,
    rel,
    color,
    ...restProps
}: MUIRouterLinkProps) => {
    if (!href) {
        return <>{children}</>
    }

    const isExternalLink = EXTERNAL_LINK_REGEX.test(href)

    if (isExternalLink) {
        return (
            <MuiLink
                href={disabled ? undefined : href}
                target={target || '_blank'}
                rel={rel || 'noopener noreferrer'}
                underline={underline}
                color={color || 'inherit'}
                {...restProps}
            >
                {children}
            </MuiLink>
        )
    }

    // Internal React Router Link
    return (
        <MuiLink
            to={disabled ? undefined : href}
            target={target}
            rel={rel || target ? 'noopener noreferrer' : undefined}
            component={CustomRouterLink}
            underline={underline}
            color={color || 'inherit'}
            {...restProps}
        >
            {children}
        </MuiLink>
    )
}
